// Vyby Live discovery categories and meters (mirrors back2/src/live/config.js).
export const LIVE_CATEGORIES = Object.freeze({
  drama: { label: 'Drama', color: '#ff4d4f', meters: ['drama_meter'] },
  comedy: { label: 'Comedy', color: '#ffd43b', meters: ['comedy_meter'] },
  insight: { label: 'Insight', color: '#4dabf7', meters: ['insight_meter'] },
  breakingNews: { label: 'Breaking News', color: '#f37021', meters: ['breakingNews_meter'] },
  sad: { label: 'Sad', color: '#748ffc', meters: ['sad_meter'] },
  shocking: { label: 'Shocking', color: '#b45cff', meters: ['shocking_meter'] },
  endearing: { label: 'Endearing', color: '#ff8cc6', meters: ['endearing_meter'] },
  raunchy: { label: 'Raunchy', color: '#e64980', meters: ['sexual_meter', 'derogatory_meter'] },
})

export const LIVE_CATEGORY_KEYS = Object.freeze(Object.keys(LIVE_CATEGORIES))

// Categories users can hide from discovery.
export const HIDEABLE_CATEGORIES = Object.freeze(['raunchy'])

export const HEATING_UP_VELOCITY = 0.08

export const categoryForMeter = (meter) =>
  LIVE_CATEGORY_KEYS.find((key) => LIVE_CATEGORIES[key].meters.includes(meter)) || null

export const meterPercent = (value) => Math.round(Math.max(0, Math.min(1, Number(value) || 0)) * 100)
